import { render } from "./domain.vue?vue&type=template&id=6a73fbfb&scoped=true"
import script from "./domain.vue?vue&type=script&lang=js"
export * from "./domain.vue?vue&type=script&lang=js"

import "./domain.vue?vue&type=style&index=0&id=6a73fbfb&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a73fbfb"]])

export default __exports__